export default __webpack_public_path__ + "static/media/dropdown-arrow-new-purple.236bd4fc.svg";